export default __webpack_public_path__ + "static/media/CSVIcon.dcd181d3.svg";